// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uxxq","type":"styles_type__12BNU","choices":"styles_choices__KnW7o"};